export const ACCESSORIES_LANG = {
  drawers: 'Aufpreis für eine Schublade mit Selbsteinzug',
  d_stetiny: 'Anschlagbürsten',
  p_stetiny: 'Anti-Staub-Bürsten',
  pozicioner: 'Positionierer'
}
